import { IWebhook } from '@/features/webhooks/store/webhook.model';

import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

export enum WebhookActionTypes {
  SEARCH_WEBHOOKS = 'WEBHOOK.SEARCH_WEBHOOKS',
  SEARCH_WEBHOOKS_SUCCESS = 'WEBHOOK.SEARCH_WEBHOOKS_SUCCESS',
  SEARCH_WEBHOOKS_FAIL = 'WEBHOOK.SEARCH_WEBHOOKS_FAIL',

  ADD_WEBHOOK = 'WEBHOOK.ADD_WEBHOOK',
  ADD_WEBHOOK_SUCCESS = 'WEBHOOK.ADD_WEBHOOK_SUCCESS',
  ADD_WEBHOOK_FAIL = 'WEBHOOK.ADD_WEBHOOK_FAIL',

  UPDATE_WEBHOOK = 'WEBHOOK.UPDATE_WEBHOOK',
  UPDATE_WEBHOOK_SUCCESS = 'WEBHOOK.UPDATE_WEBHOOK_SUCCESS',
  UPDATE_WEBHOOK_FAIL = 'WEBHOOK.UPDATE_WEBHOOK_FAIL',

  REMOVE_WEBHOOK = 'WEBHOOK.REMOVE_WEBHOOK',
  REMOVE_WEBHOOK_SUCCESS = 'WEBHOOK.REMOVE_WEBHOOK_SUCCESS',
  REMOVE_WEBHOOK_FAIL = 'WEBHOOK.REMOVE_WEBHOOK_FAIL',
}

export interface ISearchWebhookAction extends IBaseAction {
  type: typeof WebhookActionTypes.SEARCH_WEBHOOKS;
}

export interface ISearchWebhookSuccessAction extends IBaseAction {
  type: typeof WebhookActionTypes.SEARCH_WEBHOOKS_SUCCESS;
  webhooks: IWebhook[];
}

export interface ISearchWebhookFailAction extends IBaseAction {
  type: typeof WebhookActionTypes.SEARCH_WEBHOOKS_FAIL;
  error: TAppError;
}

export interface IAddWebhookAction extends IBaseAction {
  type: typeof WebhookActionTypes.ADD_WEBHOOK;
}

export interface IAddWebhookSuccessAction extends IBaseAction {
  type: typeof WebhookActionTypes.ADD_WEBHOOK_SUCCESS;
  webhook: IWebhook;
}

export interface IAddWebhookFailAction extends IBaseAction {
  type: typeof WebhookActionTypes.ADD_WEBHOOK_FAIL;
  error: TAppError;
}

export interface IUpdateWebhookAction extends IBaseAction {
  type: typeof WebhookActionTypes.UPDATE_WEBHOOK;
}

export interface IUpdateWebhookSuccessAction extends IBaseAction {
  type: typeof WebhookActionTypes.UPDATE_WEBHOOK_SUCCESS;
  webhook: IWebhook;
}

export interface IUpdateWebhookFailAction extends IBaseAction {
  type: typeof WebhookActionTypes.UPDATE_WEBHOOK_FAIL;
  error: TAppError;
}

export interface IRemoveWebhookAction extends IBaseAction {
  type: typeof WebhookActionTypes.REMOVE_WEBHOOK;
}

export interface IRemoveWebhookSuccessAction extends IBaseAction {
  type: typeof WebhookActionTypes.REMOVE_WEBHOOK_SUCCESS;
  webhookId: string;
}

export interface IRemoveWebhookFailAction extends IBaseAction {
  type: typeof WebhookActionTypes.REMOVE_WEBHOOK_FAIL;
  error: TAppError;
}

export type TWebhookAction =
  | ISearchWebhookAction
  | ISearchWebhookFailAction
  | ISearchWebhookSuccessAction
  | IAddWebhookAction
  | IAddWebhookFailAction
  | IAddWebhookSuccessAction
  | IUpdateWebhookAction
  | IUpdateWebhookFailAction
  | IUpdateWebhookSuccessAction
  | IRemoveWebhookAction
  | IRemoveWebhookFailAction
  | IRemoveWebhookSuccessAction;

export interface IWebhookState extends IBaseState {
  webhooks: IWebhook[];
}
